/*
 * Decléor — Auto-open the native cart drawer after add-to-cart
 * ---------------------------------------------------------------------------
 * On add-to-cart the theme shows its brief "Article ajouté" popup and fires
 * `theme:cart:popdown` (theme.js) — this fires on ADD only, never on removes. A
 * short delay later we slide the cart drawer open by dispatching `theme:drawer:open`
 * on #drawer-cart — the exact event the theme itself fires when the popup's "view
 * cart" button is clicked.
 *
 * Robust open-state tracking: we listen to the drawer's own theme:drawer:open /
 * theme:drawer:close events, so we never double-open (e.g. when cart_style is
 * already "drawer" and the theme opened it natively). Delay (ms) comes from the
 * script tag's data-auto-open-delay. No dependencies; no-op if the drawer is absent.
 */
(function () {
  'use strict';

  var tag = document.currentScript || document.querySelector('script[data-auto-open-delay]');
  var AUTO_OPEN = tag ? tag.getAttribute('data-auto-open') !== 'false' : true;
  var DELAY = tag ? parseInt(tag.getAttribute('data-auto-open-delay'), 10) : 1200;
  if (isNaN(DELAY) || DELAY < 0) { DELAY = 1200; }
  // How long the theme's "added" popup stays before we close it (0 = leave the theme's ~5s default).
  var POPDOWN_DURATION = tag ? parseInt(tag.getAttribute('data-popdown-duration'), 10) : 0;
  if (isNaN(POPDOWN_DURATION) || POPDOWN_DURATION < 0) { POPDOWN_DURATION = 0; }

  var timer = null;

  // Cancel the pending auto-open as soon as the shopper touches the drawer themselves. Without this, a
  // shopper who opened the drawer from the "added" popup at ~300ms and closed it at ~1000ms got it
  // re-opened (with scroll lock) at DELAY. Listeners go on the ELEMENT, not document: the theme
  // dispatches these with bubbles:false.
  (function () {
    var d0 = drawer();
    if (!d0) { return; }
    ['theme:drawer:open', 'theme:drawer:close'].forEach(function (ev) {
      d0.addEventListener(ev, function () {
        if (timer) { clearTimeout(timer); timer = null; }
      });
    });
  })();

  function drawer() {
    return document.getElementById('drawer-cart') || document.querySelector('[data-drawer="drawer-cart"]');
  }

  // Read the drawer's REAL open state from the DOM (the theme adds .drawer--visible when open) instead of
  // tracking a boolean — a close via backdrop/ESC that doesn't fire theme:drawer:close can't leave us stale
  // and silently skip every future auto-open.
  function isDrawerOpen(d) {
    return !!d && (d.classList.contains('drawer--visible') || d.classList.contains('is-open'));
  }

  // Close the theme's "added" popup via its own close button (class-agnostic, idempotent).
  function closePopdown() {
    var w = document.querySelector('[data-product-add-popdown-wrapper]');
    var btn = w && w.querySelector('[data-close-popdown]');
    if (btn) { btn.click(); }
  }

  function openCart() {
    var d = drawer();
    if (!d) { return; }
    closePopdown(); // sync: dismiss the popup as the drawer slides open
    if (isDrawerOpen(d)) { return; } // already open (native cart_style:drawer flow) — don't re-open
    d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
  }

  // The popup fires theme:cart:popdown on add. Optionally close it after a set duration
  // (to sync with the drawer), and/or open the drawer after the delay.
  document.addEventListener('theme:cart:popdown', function () {
    if (POPDOWN_DURATION > 0) { setTimeout(closePopdown, POPDOWN_DURATION); }
    if (!AUTO_OPEN) { return; }
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(openCart, DELAY);
  });
})();
